/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCollectionAnalysisRequest = {
    type: AptosCollectionAnalysisRequest.type;
    collectionId: string;
    period: AptosCollectionAnalysisRequest.period;
};

export namespace AptosCollectionAnalysisRequest {

    export enum type {
        FLOOR_PRICE = 'FLOOR_PRICE',
        AVG_PRICE_N_VOL = 'AVG_PRICE_N_VOL',
        VOL_BY_MARKET = 'VOL_BY_MARKET',
    }

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        Y1 = 'Y1',
        YTD = 'YTD',
    }


}

